import { LoanType } from "../../models";

export type TabIndex = Exclude<LoanType, "TERM_LOAN" | "RETAIL_OD">;

export type EnterpriseLoanPageSearchQuery = {
  tab: TabIndex;
  status: string[];
  pageNo: number;
  numberOfEntitiesPerPage: number;
};

export enum DrawdownLoanStatus {
  INITIATED = "INITIATED",
  DISBURSED = "DISBURSED",
  FAILED = "FAILED",
  REVERSED = "REVERSED",
  REPAID = "REPAID",
}
